"use client"

import React, {Component} from "react";
import {observer} from "mobx-react";
import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';
import {StoreContext} from "../../stores/StoreContext";
import {AppContextType} from "../../stores/StoreLoader";
import {sidebarKey} from "../admin/sidebar/SidebarContainer";
import {IReactionDisposer, reaction, toJS} from "mobx";

@observer
class AllModals extends Component {
    public disabler: IReactionDisposer | null = null;

    static contextType = StoreContext;

    static getComponent = {
        'news': dynamic(() => import('./NewsModal/NewsModal'), {loading: () => <></>}),
        'accordion': dynamic(() => import('./AccordionModal/AccordionItemModal')),
        'admin': dynamic(() => import('./AdminModal/AdminModal'), {loading: () => <></>}),
        'login': dynamic(() => import('./LoginModal'), {loading: () => <></>}),
        'gallery': dynamic(() => import("./SocialItemModal"), {loading: () => <></>}),
        'sources-modal': dynamic(() => import("./SourcesModal"), {loading: () => <></>}),
        'edit-hero': dynamic(() => import("./HeroEditor/HeroEditor"), {loading: () => <></>}),
        'file-preview': dynamic(() => import("./FilePreviewModal"), {loading: () => <></>}),
        'collectionManagement': dynamic(() => import("./CollectionManagementModal"), {loading: () => <></>}),
        'peopleCollectionManagement': dynamic(() => import("./PeopleCollectionManagementModal/PeopleCollectionManagementModal"), {loading: () => <></>}),
        'schoolBlocksEvent': dynamic(() => import("./SchoolBlocksEventModal"), {loading: () => <></>}),
        'block': dynamic(() => import("./BlockModal"), {loading: () => <></>}),
        "schoolDistrict": dynamic(() => import("./SchoolDistrictModal"), {ssr: false}),
        "sbOrganization": dynamic(() => import("./SchoolBlocksOrganizationModal/SchoolBlocksOrganizationModal"), {ssr: false}),
        "addOrEditBlock": dynamic(() => import("./AddEditBlockModal/AddOrEditBlock"), {loading: () => <></>}),
        "toolDrawerGrid": dynamic(() => import("./AddEditBlockModal/ToolDrawerGrid"), {loading: () => <></>}),
        "addOrEditAlert": dynamic(() => import("./AlertEditModal/AlertEditModal"), {loading: () => <></>}),
        "helpModal": dynamic(() => import("./HelpModal"), {ssr: false}),
        "permissions": dynamic(() => import("./PermissionsModal/PermissionsModal"), {loading: () => <></>}),
        "calendarManagement": dynamic(() => import("./CalendarManagementModal/CalendarManagementModal"), {loading: () => <></>}),
        "calendarList": dynamic(() => import("./CalendarManagementModal/CalendarListModal"), {loading: () => <></>}),
        "comparePages": dynamic(() => import("./ComparePagesModal"), {loading: () => <></>}),
        "revertPage": dynamic(() => import("./RevertDialog"), {loading: () => <></>}),
        "fluxCapacitor": dynamic(() => import("./FluxCapacitorTimeline"), {ssr: false}),
        "googleFilePicker": dynamic(() => import("./GoogleFilePicker"), {loading: () => <></>}),
        "schoolBlocksPerson": dynamic(() => import("./PersonModal/SchoolBlocksPersonModal"), {loading: () => <></>}),
        "iconUpload": dynamic(() => import("./IconUpload"), {loading: () => <></>}),
        "faviconUpload": dynamic(() => import("./IconUpload"), {loading: () => <></>}),
        "heroImageUpload": dynamic(() => import("./HeroEditor/HeroImageUpload"), {loading: () => <></>}),
        "statementUpload": dynamic(() => import("./StatementImageUpload/StatementImageUpload"), {loading: () => <></>}),
        "iosAppInstallHelp": dynamic(() => import("./iosAppInstallHelp"), {loading: () => <></>}),
        "syncGroupsModal": dynamic(() => import("./SyncGroupsModal/SyncGroupsModal"), {loading: () => <></>}),
        "notificationChannels": dynamic(() => import("./NotificationChannels/NotificationChannels"), {loading: () => <></>}),
        "recipientsPreview": dynamic(() => import("./NotificationRecipientsPreviewModal"), {loading: () => <></>}),
        "brightarrow": dynamic(() => import("./BrightArrowModal"), {loading: () => <></>}),
        "coursework": dynamic(() => import("./CourseWorkModal"), {loading: () => <></>}),
        "blockui": dynamic(() => import("./BlockUIModal"), {loading: () => <></>}),
        "callToActionEditor": dynamic(() => import("./CallToActionEditor/CallToActionEditorModal"), {loading: () => <></>}),
        "organizationSelection": dynamic(() => import("./OrganizationSelectionModal"), {loading: () => <></>}),
        "shareContentItem": dynamic(() => import("./ShareContentItemModal"), {loading: () => <></>}),
        "autoApproveManagement": dynamic(() => import("./AutoApproveManagementModal"), {loading: () => <></>}),
        "terraceManagementModal": dynamic(() => import("./TerraceManagement/TerraceManagementModal"), {loading: () => <></>}),
        "iframe": dynamic(() => import("./IframeModal"), {loading: () => <></>}),
        "cleverfeedOrgReport": dynamic(() => import("./CleverFeedOrgReportModal"), {loading: () => <></>}),
        "spotlightTileEditor": dynamic(() => import("./SpotlightTileEditor"), {loading: () => <></>}),
        "tileImageUpload": dynamic(() => import("./TileImageUpload"), {loading: () => <></>}),
        "activity": dynamic(() => import("./ActivityModal/ActivityModal"), {loading: () => <></>}),
        "AddOrEditMessagingListModal": dynamic(() => import("./Messaging/AddOrEditMessagingListModal"), {loading: () => <></>}),
        "messagingListPreview": dynamic(() => import("./Messaging/MessagingListPreviewModal"), {loading: () => <></>}),
        "deliverySummary": dynamic(() => import("./AlertEditModal/NotificationSummaryModal"), {loading: () => <></>}),
        "textInput": dynamic(()=> import("./TextInputModal"), {loading: () => <></>}),
        "info": dynamic(()=> import("./InfoModal"), {loading: () => <></>}),
        "contactForm": dynamic(()=> import("./ContactFormModal"), {loading: () => <></>}),
        "locationSelection": dynamic(() => import("./LocationSelectionModal"), {loading: () => <></>}),
        "languageSelection": dynamic(() => import("./LanguageModal"), {loading: () => <></>}),
    };

    static propTypes = {
        modalObj: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            type: PropTypes.string.isRequired,
            theme: PropTypes.oneOf(['classic', 'transparent']),
        }),
    };

    state: {
        modalStack: Array<{
            type: string,
            id: string | number,
            theme?: string,
        }>
    } = {
        modalStack: []
    }

    componentDidMount() {
        const {modalStore} = this.context as AppContextType;

        this.setState({
            modalStack: toJS(modalStore.stack)
        })

        this.disabler = reaction(() => modalStore.stack.length, () => {
            if (modalStore.stack.length > this.state.modalStack.length) {
                // a modal was added, add it immediately - uses spread operator because we don't want to preserve
                // observability of modalStore.stack, but we DO want to preserve any non-serializable values of each
                // individual item
                this.setState({modalStack: [...modalStore.stack]})
            } else {
                // a modal was removed, set a timeout so we can transition out
                setTimeout(() => {
                    this.setState({modalStack: [...modalStore.stack]})
                }, 500)
            }
        })
    }

    componentWillUnmount() {
        if (this.disabler) {
            this.disabler();
        }
    }

    render() {
        const {modalStore} = this.context as AppContextType;

        return (
            <div id="allModalContainer">
                {this.state.modalStack.map((modalObj, index) => {
                    if (modalObj.type === sidebarKey) {
                        // we want the sidebar in the modalStack to consume a vertical space, but we don't want
                        // to actually render anything here
                        return <React.Fragment key={`sidebar-${index}`} />
                    }

                    const ModalComponent = AllModals.getComponent[modalObj.type];
                    return (
                        <ModalComponent
                            key={modalObj.type}
                            id={modalObj.id}
                            type={modalObj.type}
                            theme={modalObj.theme ? modalObj.theme : 'classic'}
                            index={index}
                            modalObj={modalObj}
                            active={modalStore.stack.findIndex(modal => JSON.stringify(modalObj) === JSON.stringify(modal)) !== -1}
                        />
                    );
                })}
            </div>
        );
    }
}

export default AllModals
